import { render } from "./FreeProductDescription.vue?vue&type=template&id=7e69c4cd&scoped=true"
import script from "./FreeProductDescription.vue?vue&type=script&lang=ts"
export * from "./FreeProductDescription.vue?vue&type=script&lang=ts"

import "./FreeProductDescription.vue?vue&type=style&index=0&id=7e69c4cd&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7e69c4cd"

export default script